import React, { useState } from 'react';
import { Card, Row, Col, Button } from 'react-bootstrap';
// import MainPage from './pages/MainPage';
// import TthPage from './pages/TthPage';
// import TakeUpPage from './pages/TakeUpPage';
// import MeterPage from './pages/MeterPage';
import './skip2250.css';
import dayjs from 'dayjs';

const Skip2250Hmi = ({ machineLive, feed = null }) => {
  const [page, setPage] = useState('MAIN');

  console.log('Rendering Skip2250Hmi with live data:', machineLive);

  const renderPage = () => {
    switch (page) {
      case 'MAIN':
        return <MainPage machineLive={machineLive} feed={feed} />;
      case 'TTH':
        return <TthPage machineLive={machineLive} feed={feed} />;
      case 'TAKEUP':
        return <TakeUpPage machineLive={machineLive} feed={feed} />;
      case 'METER':
        return <MeterPage machineLive={machineLive} feed={feed} />;
      default:
        return <MainPage machineLive={machineLive} feed={feed} />;
    }
  };

  return (
    <Card className="skip2250-card p-3">
      {/* PAGE CONTENT */}
      {renderPage()}

      {/* FOOTER MENU */}
      <Row className="mt-4 g-2 text-center">
        <Col>
          <div
            className={`hmi-menu-btn ${page === 'MAIN' ? 'active' : ''}`}
            onClick={() => setPage('MAIN')}
          >
            MAIN PAGE
          </div>
        </Col>
        <Col>
          <div
            className={`hmi-menu-btn ${page === 'TTH' ? 'active' : ''}`}
            onClick={() => setPage('TTH')}
          >
            TTH PAGE
          </div>
        </Col>
        <Col>
          <div
            className={`hmi-menu-btn ${page === 'TAKEUP' ? 'active' : ''}`}
            onClick={() => setPage('TAKEUP')}
          >
            TAKE-UP PAGE
          </div>
        </Col>
        <Col>
          <div
            className={`hmi-menu-btn ${page === 'METER' ? 'active' : ''}`}
            onClick={() => setPage('METER')}
          >
            METER PAGE
          </div>
        </Col>
        <Col>
          <div
            className={`hmi-menu-btn ${page === 'ALARM' ? 'active' : ''}`}
            onClick={() => setPage('ALARM')}
          >
            ALARM PAGE
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default Skip2250Hmi;

const MainPage = ({ machineLive, feed }) => {
  return (
    <>
      {/* SPEED BAR */}
      <Row className="g-2 mb-3 text-center">
        <Col>
          <div className="hmi-box blue">
            <div className="hmi-label">ACT LINE SPEED</div>
            <div className="hmi-value">{machineLive.ACT_SPEED}</div>
          </div>
        </Col>
        <Col>
          <div className="hmi-box cyan">
            <div className="hmi-label">MAX LINE SPEED</div>
            <div className="hmi-value">{machineLive.MAX_RAMP_SPEED_VALUE}</div>
          </div>
        </Col>
        <Col>
          <div className="hmi-box teal">
            <div className="hmi-label">MAX LINE LIMIT</div>
            <div className="hmi-value">{machineLive.MAX_RAMP_LIMIT_VALUE}</div>
          </div>
        </Col>
        <Col>
          <div className="hmi-box yellow small">
            <div className="hmi-value" title={feed?.title || undefined} style={feed?.stale ? { color: '#F87171' } : undefined}>{feed?.label ? `${feed.label} în urmă` : dayjs().format(' HH:mm:ss')}</div>
          </div>
        </Col>
      </Row>

      {/* TITLE */}
      <h3 className="text-center hmi-title mb-3">MAIN PAGE</h3>

      {/* MID ROW – CAPSTAN / TTH / BOW / MEASURING */}
      <Row className="g-3 text-center align-items-start">
        {/* CAPSTAN */}
        <Col md={3}>
          <div className="hmi-box white">
            <div className="hmi-label">CAPSTAN</div>

            <div className="sub-box green">
              <div className="sub-label">RPM</div>
              <div className="sub-value">{machineLive.CAPSTAN_MOTOR_RPM}</div>
            </div>

            <div className="sub-box blue-light mt-2">
              <div className="sub-label">CURRENT</div>
              <div className="sub-value">{`${machineLive.CAPSTAN_CURRENT} A`}</div>
            </div>
          </div>
        </Col>

        {/* TTH */}
        <Col md={3}>
          <div className="hmi-box white">
            <div className="hmi-label">TTH</div>

            <div className="sub-box blue-light">
              <div className="sub-label">RPM</div>
              <div className="sub-value">{machineLive.TTH1_RPM}</div>
            </div>

            <div className="sub-box blue-light mt-2">
              <div className="sub-label">CURRENT</div>
              <div className="sub-value">{`${machineLive.TTH1_CURRENT} A`}</div>
            </div>
          </div>
        </Col>

        {/* BOW */}
        <Col md={3}>
          <div className="hmi-box white">
            <div className="hmi-label">BOW</div>

            <div className="sub-box blue-light">
              <div className="sub-label">RPM</div>
              <div className="sub-value">{machineLive.BOW_MAX_RPM}</div>
            </div>

            <div className="sub-box blue-light mt-2">
              <div className="sub-label">CURRENT</div>
              <div className="sub-value">{`${machineLive.BOW_CURRENT} A`}</div>
            </div>
          </div>
        </Col>

        {/* MEASURING */}
        <Col md={3}>
          <div className="hmi-box yellow-measure">
            <div className="hmi-label">MEASURING</div>

            <div className="sub-measure">
              <div className="measure-label">SET</div>
              <div className="measure-val">{machineLive.METER_SET}</div>
            </div>

            <div className="sub-measure mt-1">
              <div className="measure-label">ACTUAL</div>
              <div className="measure-val">
                {machineLive.METER_ACT.toFixed(2)}
              </div>
            </div>

            <div className="sub-measure mt-1">
              <div className="measure-label">TOTAL</div>
              <div className="measure-val">
                {machineLive.METER_TOTAL.toFixed(2)}
              </div>
            </div>
          </div>

          {/* RIGHT TWO RESET BUTTONS */}
          <div className="reset-box mt-2">
            <Button className="hmi-btn hmi-stop w-100 mb-2">
              ACTUAL RESET
            </Button>
            <Button className="hmi-btn hmi-stop w-100">TOTAL RESET</Button>
          </div>
        </Col>
      </Row>

      {/* LOWER BAR – CRANE, TTH, BOW */}
      <Row className="mt-4 g-2 text-center align-items-center">
        <Col>
          <div className="direction-box">
            <div className="dir-title">CRANE</div>
            {`${machineLive.MOTOR_DATA}` ? (
              <div className="dir-red">READY</div>
            ) : (
              <div className="dir-green">READY</div>
            )}
          </div>
        </Col>

        <Col>
          <div className="direction-box">
            <div className="dir-title">TTH DIRECTION</div>
            <div className="dir-blue">
              {`${machineLive.TTH1_DIRECTION}` ? 'Z' : 'S'}
            </div>
          </div>
        </Col>

        <Col>
          <div className="direction-box">
            <div className="dir-title">TTH LAY LENGTH</div>
            <div className="dir-blue">{machineLive.TTH1_LAY_LENTH}</div>
          </div>
        </Col>

        <Col>
          <div className="direction-box">
            <div className="dir-title">BOW DIRECTION</div>
            <div className="dir-blue">
              {`${machineLive.BOW_DIRECTION}` ? 'Z' : 'S'}
            </div>
          </div>
        </Col>

        <Col>
          <div className="direction-box">
            <div className="dir-title">BOW LAY LENGTH</div>
            <div className="dir-blue">{machineLive.BOW_LAY_LENGHT}</div>
          </div>
        </Col>
      </Row>
    </>
  );
};

const TthPage = ({ machineLive, feed }) => {
  return (
    <>
      {/* TOP SPEED BAR */}
      <Row className="g-2 mb-3 text-center">
        <Col>
          <div className="hmi-box blue">
            <div className="hmi-label">ACT LINE SPEED</div>
            <div className="hmi-value">{machineLive.ACT_SPEED}</div>
          </div>
        </Col>
        <Col>
          <div className="hmi-box cyan">
            <div className="hmi-label">MAX LINE SPEED</div>
            <div className="hmi-value">{machineLive.MAX_RAMP_SPEED_VALUE}</div>
          </div>
        </Col>
        <Col>
          <div className="hmi-box teal">
            <div className="hmi-label">MAX LINE LIMIT</div>
            <div className="hmi-value">{machineLive.MAX_RAMP_LIMIT_VALUE}</div>
          </div>
        </Col>
        <Col>
          <div className="hmi-box yellow small">
            <div className="hmi-value" title={feed?.title || undefined} style={feed?.stale ? { color: '#F87171' } : undefined}>{feed?.label ? `${feed.label} în urmă` : dayjs().format(' HH:mm:ss')}</div>
          </div>
        </Col>
      </Row>

      {/* TITLE */}
      <h3 className="text-center hmi-title mb-2">TTH</h3>

      {/* LAY LENGTH + S DIRECTION + JOG SET VALUE */}
      <Row className="mb-3 text-center align-items-center">
        {/* LAY LENGTH */}
        <Col md={3}>
          <div className="hmi-box yellow">
            <div className="hmi-label">LAY LENGTH</div>
            <div className="hmi-value">{machineLive.TTH1_LAY_LENTH}</div>
          </div>
        </Col>

        {/* DIRECTION S */}
        <Col md={3}>
          <div className="direction-big">
            {' '}
            {`${machineLive.TTH1_DIRECTION}` ? 'Z' : 'S'}
          </div>
        </Col>

        {/* JOG SET VALUE */}
        <Col md={3}>
          <div className="hmi-box gray">
            <div className="hmi-label">JOG SET VALUE</div>
            <div className="hmi-value">{machineLive.TTH1_JOG_REF}</div>
          </div>
        </Col>
      </Row>

      {/* MAIN CONTENT: TAPE A | VALUES TABLE | TAPE B */}
      <Row className="g-3">
        {/* LEFT PANEL - TAPE A */}
        <Col md={3} className="text-center">
          <Button
            className={`tape-btn ${
              machineLive?.TTH1_A_TAPE_BREAK_ON_OFF ? 'green' : 'red'
            } w-100 mb-2`}
          >
            TAPE A BREAK OFF
          </Button>
          <Button
            className={`tape-btn ${
              machineLive.TTH1_A_TAPE_END_ON_OFF ? 'green' : 'red'
            } w-100 mb-2`}
          >
            TAPE A END OFF
          </Button>

          <Button className="tape-btn  w-100 mt-4">NEW TAPE (A)</Button>
        </Col>

        {/* MIDDLE TABLE */}
        <Col md={6}>
          <div className="values-table p-2">
            {/* Table header */}
            <div className="table-row header">
              <div>Values (mm)</div>
              <div>TAPE A</div>
              <div>TAPE B</div>
            </div>

            {/* Table body */}
            {[
              [
                'Outer Diameter',
                `${machineLive.TTH1_A_TAPE_OUTTER_DIA}`,
                `${machineLive.TTH1_B_TAPE_OUTTER_DIA}`
              ],
              [
                'Inner Diameter',
                `${machineLive.TTH1_A_INNER_VALUE}`,
                `${machineLive.TTH1_B_INNER_VALUE}`
              ],
              [
                'Stop Diameter',
                `${machineLive.TTH1_A_STOP_VALUE}`,
                `${machineLive.TTH1_B_STOP_VALUE}`
              ],
              [
                'Stop Diameter 2',
                `${machineLive.TTH1_A_STOP_VALUE}`,
                `${machineLive.TTH1_B_STOP_VALUE}`
              ],
              [
                'Tape Thickness',
                `${machineLive.TTH1_A_TAPE_THICKNESS}`,
                `${machineLive.TTH1_B_TAPE_THICKNESS}`
              ],
              [
                'Actual Diameter',
                `${machineLive.TTH1_A_ZONE_LAZER_ACT_DIA}`,
                `${machineLive.TTH1_B_ZONE_LAZER_ACT_DIA}`
              ]
            ].map(([label, a, b]) => (
              <div className="table-row" key={label}>
                <div className="label-cell">{label}</div>
                <div className="val-cell">{a}</div>
                <div className="val-cell">{b}</div>
              </div>
            ))}
          </div>
        </Col>

        {/* RIGHT PANEL – TAPE B */}
        <Col md={3} className="text-center">
          <Button className="tape-btn red w-100 mb-2">TAPE B BREAK OFF</Button>
          <Button className="tape-btn red w-100 mb-2">TAPE B END OFF</Button>

          <Button className="tape-btn  w-100 mt-4">NEW TAPE (B)</Button>
        </Col>
      </Row>
    </>
  );
};
const MeterPage = ({ machineLive, feed }) => {
  return (
    <>
      {/* TOP BAR */}
      <Row className="g-2 mb-3 text-center">
        <Col>
          <div className="hmi-box blue">
            <div className="hmi-label">ACT LINE SPEED</div>
            <div className="hmi-value">{machineLive.ACT_SPEED}</div>
          </div>
        </Col>
        <Col>
          <div className="hmi-box cyan">
            <div className="hmi-label">MAX LINE SPEED</div>
            <div className="hmi-value">{machineLive.MAX_RAMP_SPEED_VALUE}</div>
          </div>
        </Col>
        <Col>
          <div className="hmi-box teal">
            <div className="hmi-label">MAX LINE LIMIT</div>
            <div className="hmi-value">{machineLive.MAX_RAMP_LIMIT_VALUE}</div>
          </div>
        </Col>
        <Col>
          <div className="hmi-box yellow small">
            <div className="hmi-value" title={feed?.title || undefined} style={feed?.stale ? { color: '#F87171' } : undefined}>{feed?.label ? `${feed.label} în urmă` : dayjs().format(' HH:mm:ss')}</div>
          </div>
        </Col>
      </Row>

      <h3 className="text-center hmi-title mb-3">METER</h3>

      {/* MAIN LAYOUT */}
      <Row className="g-4 justify-content-center">
        {/* LEFT BUTTONS */}
        <Col md={3} className="text-center">
          <button className="meter-btn">METER WARNING/STOP</button>
          <button className="meter-btn mt-2">METER STOP</button>
        </Col>

        {/* CENTER SECTION */}
        <Col md={6} className="text-center">
          {/* GRAY BOX */}
          <div className="meter-gray-box mx-auto">
            <div className="meter-row">
              <span className="meter-label">SET</span>
              <div className="meter-yellow">
                {machineLive.METER_SET || '99999.9 m'}
              </div>
            </div>

            <div className="meter-row">
              <span className="meter-label">ACTUAL</span>
              <div className="meter-white">
                {machineLive.METER_ACT || '0.0 m'}
              </div>
            </div>

            <div className="meter-row">
              <span className="meter-label">TOTAL</span>
              <div className="meter-white">
                {machineLive.METER_TOTAL || '0.0 m'}
              </div>
            </div>

            <div className="meter-row">
              <span className="meter-label">SLOW STARTED</span>
              <div className="meter-black">
                {machineLive.METER_SLOW_STARTED}
              </div>
            </div>
          </div>

          {/* RESET BUTTONS */}

          {/* COEFF */}
          <div className="coeff-box mt-3">
            <span className="coeff-label">COEFF. 1</span>
            <span className="coeff-yellow">
              {machineLive?.coeff || '1.000000'}
            </span>
            <span className="coeff-note">(1.0)</span>
          </div>
        </Col>

        <Col md={3} className="text-center">
          <button className="meter-btn center-reset-btn">
            ACTUAL METER RESET
          </button>
          <button className="meter-btn center-reset-btn mt-2">
            TOTAL METER RESET
          </button>
        </Col>
        {/* RIGHT SIDE (EMPTY) */}
        <Col md={3}></Col>
      </Row>
    </>
  );
};

const TakeUpPage = ({ machineLive, feed }) => {
  return (
    <>
      {/* TOP SPEED BAR */}
      <Row className="g-2 mb-3 text-center">
        <Col>
          <div className="hmi-box blue">
            <div className="hmi-label">ACT LINE SPEED</div>
            <div className="hmi-value">{machineLive.ACT_SPEED}</div>
          </div>
        </Col>
        <Col>
          <div className="hmi-box cyan">
            <div className="hmi-label">MAX LINE SPEED</div>
            <div className="hmi-value">{machineLive.MAX_RAMP_SPEED_VALUE}</div>
          </div>
        </Col>
        <Col>
          <div className="hmi-box teal">
            <div className="hmi-label">MAX LINE LIMIT</div>
            <div className="hmi-value">{machineLive.MAX_RAMP_LIMIT_VALUE}</div>
          </div>
        </Col>
        <Col>
          <div className="hmi-box yellow small">
            <div className="hmi-value" title={feed?.title || undefined} style={feed?.stale ? { color: '#F87171' } : undefined}>{feed?.label ? `${feed.label} în urmă` : dayjs().format(' HH:mm:ss')}</div>
          </div>
        </Col>
      </Row>

      {/* TITLE */}
      <h3 className="text-center hmi-title mb-3">TAKE-UP</h3>

      {/* CONTENT */}
      <Row className="g-3 align-items-start">
        {/* LEFT PANEL (BLACK BOX LIKE IN HMI) */}
        <Col md={3}>
          <div className="left-panel">
            {/* CARD 1 — WINDER */}
            <div className="black-card">
              <div className="black-title">WINDER</div>

              <div className="black-line">
                <span>{machineLive.WINDING_CURRENT.toFixed(2)}</span>
                <span>A</span>
              </div>

              <div className="black-line">
                <span>{machineLive.WINDING_ACT_TENSION.toFixed(2)}</span>
                <span>%</span>
              </div>

              <div className="black-line">
                <span>{machineLive.WINDING_RPM.toFixed(2)}</span>
                <span>RPM</span>
              </div>
            </div>

            {/* CARD 2 — TRAVERS */}
            <div className="black-card">
              <div className="black-title">TRAVERS</div>

              <div className="black-line">
                <span>{machineLive.TRAVERSE_CURRENT.toFixed(2)}</span>
                <span>A</span>
              </div>

              <div className="black-line">
                <span>{machineLive.TRAVERSE_LOAD.toFixed(2)}</span>
                <span>%</span>
              </div>

              <div className="black-line">
                <span>{machineLive.TARVERSE_RPM.toFixed(2)}</span>
                <span>RPM</span>
              </div>
            </div>

            {/* CARD 3 — OPEN/CLOSE */}
            <div className="black-card">
              <div className="black-title">OPEN/CLOSE</div>

              <div className="black-line">
                <span>{machineLive.OPEN_CLOSE_CURRENT.toFixed(2)}</span>
                <span>A</span>
              </div>

              <div className="black-line">
                <span>{machineLive.OPEN_CLOSE_LOAD.toFixed(2)}</span>
                <span>%</span>
              </div>

              <div className="black-line">
                <span>{machineLive.OPEN_CLOSE_RPM.toFixed(2)}</span>
                <span>RPM</span>
              </div>
            </div>

            {/* REEL SPEED */}

            {/* MOTOR DATA */}
            <button className="motor-data-btn">Motor Data</button>
          </div>
        </Col>

        {/* CENTER IMAGE */}
        <Col md={6} className="text-center">
          <div className="blue-value-box">
            <div className="value-label">Reel Speed</div>
            <div className="value-big">{machineLive.WINDING_REEL_RPM} RPM</div>
          </div>

          {/* ACT TENSION */}
          <div className="blue-value-box">
            <div className="value-label">Act Tension</div>
            <div className="value-big">
              {machineLive.WINDING_ACT_TENSION.toFixed(2)} %
            </div>
          </div>
          <div className="takeup-machine-box">
            {/* <img src={yourMachineImage} className="machine-img" /> */}
            <div className="placeholder-machine">MACHINE IMAGE</div>

            <div className="direction-pad">
              <div className="pad-btn">↑</div>
              <div className="pad-btn">↓</div>
              <div className="pad-btn">←</div>
              <div className="pad-btn">→</div>
            </div>
          </div>
        </Col>

        {/* RIGHT BUTTONS */}
        <Col md={3} className="text-center">
          <Button className="start-btn w-100 mb-3">START</Button>
          <Button className="stop-btn w-100">STOP</Button>

          <div className="alarm-box mt-4">
            TAKE UP
            <br />
            STOP ALARM
            <br />
            PASSIVE
          </div>
        </Col>
      </Row>

      {/* MENU will be outside in main component */}
    </>
  );
};
